import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, Content, ToastController } from 'ionic-angular';
import { FormBuilder, FormGroup } from '@angular/forms';
import 'rxjs/add/operator/toPromise';

import * as moment from 'moment';
import { VariablesProvider } from '../../providers/variables/variables';
import { FuncionesProvider } from '../../providers/funciones/funciones';
import { CalendarModalOptions } from "ion2-calendar";
import * as XLSX from '../../xlsx';
import { File } from '@ionic-native/file';
import * as jsPDF from '../../jspdf';
import { Storage } from '@ionic/storage';
import { PicajesPage } from "../../pages/picajes/picajes";

@IonicPage()
@Component({
  selector: 'page-informes',
  templateUrl: 'informes.html',
})
export class InformesPage {

  @ViewChild(Content) content: Content;

  public mostrarerror = false;
  datosacceso;
  usuariodatos;
  id;
  subtema;
  code;
  email;
  contrasena;
  usuarioacceso;
  myForm: FormGroup;

  scrollGuardado: number = 0;
  deboRestaurarScroll: boolean = false;

  totalHorasTrabajadas = '00:00';
  totalHorasExtras = '00:00';
  totalHorasDefecto = '00:00';
  totalRegistros = 0;

  totalHorasTranscurridas = '00:00';
  totalHorasParadas = '00:00';
  totalHorasAlmorzando = '00:00';

  imagenactual;
  fileName: string;

  pages: Array<{ title: string, component: any }>;
  usuarioaccesoarray: Array<{ usuarioacceso: string }>;
  usuariodatosarray: Array<{ usuariodatos: string }>;

  trabajadores;
  informetrabajadores;
  informetrabajadoressindetalles;

  filtrotrabajador;
  filtroobra;
  filtrofecha;
  num: any;
  FechaIni: any;
  FechaFin: any;
  campo_trabajador: any;
  valortrabajador;
  valorempresa;
  valorobra;
  valorturno;
  valorinforme;
  tipodeinforme;

  Informe;
  trabajadores2;

  date: string;
  type: 'string';

  empresas;
  sobras;
  turnos;
  valo = "654321123456";
  public users;
  public trabaja;
  DIAdehoy;
  private asignacionesTurnos: { [clave: string]: any } = {};
  private asignacionesMesesCargados: { [mes: string]: boolean } = {};

  horasTrabajadasPorClave: { [key: string]: string } = {};

  doc = new jsPDF();

  optionsRange: CalendarModalOptions = {
    pickMode: "range",
    color: 'dark',
    weekStart: 1,
    weekdays: ['DO', 'LU', 'MA', 'MI', 'JU', 'VI', 'SA'],
    canBackwardsSelected: true,
    cssClass: 'font-size:6'
  };

  constructor(
    private storage: Storage,
    private toastCtrl: ToastController,
    public funciones: FuncionesProvider,
    public variablesglobales: VariablesProvider,
    public navParams: NavParams,
    public navCtrl: NavController,
    public fb: FormBuilder,
    public file: File
  ) {

    const f = new Date();
    this.DIAdehoy = f.getFullYear() + "-" + ("0" + (f.getMonth() + 1)).slice(-2) + "-" + ("0" + (f.getDate())).slice(-2);

    this.variablesglobales.muestragif = "si";

    this.Informe = "N";
    this.valortrabajador = "654321123456";
    this.valorempresa = "654321123456";
    this.valorobra = "654321123456";
    this.valorturno = "654321123456";

    this.FechaIni = this.DIAdehoy;
    this.FechaFin = this.DIAdehoy;

    this.valorobra = this.variablesglobales.OBRA;
    this.campo_trabajador = this.variablesglobales.CODIGOTRABAJADOR;
    this.filtrofecha = "S";
    this.filtrotrabajador = "S";
    this.filtroobra = "S";
    this.tipodeinforme = "normal";

    this.funciones.obtienetrabajadores(this.valortrabajador).then(
      data => {
        this.trabaja = data;
      }
    ).catch(error => {
      console.log(error);
    });

    this.obtenertrabajadores(this.valo);

    this.funciones.obtieneusers(this.variablesglobales.CLIENTES_RAZSOCIAL).then(
      data => {
        this.users = data;
      }
    ).catch(error => {
      console.log(error);
    });

    this.creaelinforme();
  }

  private claveAsignacion(fecha: any, codigo: any): string {
    return String(fecha || '').substr(0, 10) + '|' + String(codigo || '').trim();
  }

  private mesDeFecha(fecha: any): string {
    const valor = String(fecha || '').substr(0, 10);
    return /^\d{4}-\d{2}-\d{2}$/.test(valor) ? valor.substr(0, 7) : '';
  }

  private diaTurno(fecha: any): string {
    const dia = new Date(String(fecha).substr(0, 10) + 'T00:00:00Z').getUTCDay();
    return ['D', 'L', 'M', 'X', 'J', 'V', 'S'][dia];
  }

  private buscarTurno(asignacion: any): any {
    const id = asignacion && asignacion.turno_id;
    const nombre = String(asignacion && asignacion.turno || '').trim().toLowerCase();
    return (this.turnos || []).find((turno: any) =>
      (id !== null && id !== undefined && String(turno.ID) === String(id)) ||
      (nombre && String(turno.NOMBRE || turno.TURNO || '').trim().toLowerCase() === nombre)
    ) || null;
  }

  private async cargarAsignacionesMes(mes: string): Promise<void> {
    if (!mes || this.asignacionesMesesCargados[mes]) { return; }
    const partes = mes.split('-');
    try {
      const filas = await this.funciones.obtieneAsignacionesMesTodas(this.variablesglobales.CLIENTES_RAZSOCIAL,
        Number(partes[0]), Number(partes[1])).toPromise();
      (filas || []).forEach((fila: any) => {
        if (fila && fila.fecha && fila.trabajador && fila.turno_id !== null && fila.turno_id !== undefined && fila.turno_id !== '') {
          this.asignacionesTurnos[this.claveAsignacion(fila.fecha, fila.trabajador)] = fila;
        }
      });
    } catch (error) {
      console.log('No se pudieron cargar las asignaciones del informe', error);
    }
    this.asignacionesMesesCargados[mes] = true;
  }

  private aplicarAsignacionFila(fila: any, asignacion: any, fecha: string): void {
    if (!fila || !asignacion) { return; }
    const turno = this.buscarTurno(asignacion);
    const nombre = turno ? (turno.NOMBRE || turno.TURNO) : asignacion.turno;
    if (nombre) { fila.TURNO = nombre; }
    if (!turno) { return; }
    const dia = this.diaTurno(fecha);
    if (turno[dia] !== undefined) { fila.HORAS_PREVISTAS = turno[dia]; }
    ['HORA_ENTRADA', 'HORA_SALIDA', 'CORTESIA', 'ALMUERZO', 'CENA', 'MODO'].forEach(campo => {
      if (turno[campo] !== undefined) { fila[campo] = turno[campo]; }
    });
  }

  private async aplicarAsignacionesInforme(filas: any[]): Promise<any[]> {
    const lista = Array.isArray(filas) ? filas : [];
    const meses: { [mes: string]: boolean } = {};
    lista.forEach(fila => { const mes = this.mesDeFecha(fila && fila.FECHA); if (mes) { meses[mes] = true; } });
    for (const mes of Object.keys(meses)) { await this.cargarAsignacionesMes(mes); }
    let fechaActual = '';
    let codigoActual = '';
    lista.forEach(fila => {
      if (fila && /^\d{4}-\d{2}-\d{2}$/.test(String(fila.FECHA || ''))) { fechaActual = fila.FECHA; }
      if (fila && fila.CODIGO) { codigoActual = fila.CODIGO; }
      const asignacion = this.asignacionesTurnos[this.claveAsignacion(fechaActual, codigoActual)];
      if (asignacion) { this.aplicarAsignacionFila(fila, asignacion, fechaActual); }
    });
    return lista;
  }

  ionViewDidLoad() { }

  ionViewDidEnter() {
    if (this.deboRestaurarScroll) {
      this.deboRestaurarScroll = false;

      setTimeout(() => {
        if (this.content) {
          this.content.scrollTo(0, this.scrollGuardado, 0);
        }
      }, 200);
    }
  }

  recargarInforme(): Promise<any> {
      return new Promise<void>((resolve) => {
      this.variablesglobales.muestragif = "si";
      this.variablesglobales.muestraerror = "no";

      if (this.variablesglobales.CODIGOTRABAJADOR != "") {
        this.valortrabajador = this.variablesglobales.CODIGOTRABAJADOR;
      }

      this.informetrabajadores = [];
      this.informetrabajadoressindetalles = [];
      this.horasTrabajadasPorClave = {};

      this.funciones.informeobras(
        this.valortrabajador,
        this.valorobra,
        this.valorturno,
        this.valorempresa,
        this.FechaIni,
        this.FechaFin,
        this.variablesglobales.MODO
      ).then(async data => {

        try {
          this.turnos = await this.funciones.obtieneturnos(this.valo);
        } catch (error) {
          this.turnos = this.turnos || [];
        }
        const filasInforme = this.funciones.normalizarJornadasMedianoche ?
          await this.funciones.normalizarJornadasMedianoche(
            data as any[], this.valortrabajador, this.FechaIni, this.FechaFin, false) : data;
        await this.aplicarAsignacionesInforme(filasInforme as any[]);
        this.informetrabajadores = filasInforme;

        this.obtenerobras(this.valo);
        this.obtenerempresas(this.valo);

        this.totalHorasTranscurridas = '00:00';
        this.totalHorasParadas = '00:00';
        this.totalHorasAlmorzando = '00:00';
        this.recalcularHorasTrabajadasPorFila();

        this.variablesglobales.muestragif = "no";
        this.variablesglobales.muestraerror = "no";

        resolve();

      }).catch(error => {
        this.variablesglobales.muestragif = "no";
        this.variablesglobales.muestraerror = "si";
        console.log(error);
        resolve();
      });
    });
  }

  private pad2(n: number): string {
    return n < 10 ? '0' + n : '' + n;
  }

  private hhmmToMinutes(hora: string): number {
    if (!hora) { return 0; }
    const partes = String(hora).split(':');
    if (partes.length < 2) { return 0; }

    const h = Number(partes[0]) || 0;
    const m = Number(partes[1]) || 0;
    return (h * 60) + m;
  }

  private minutesToHHMM(total: number): string {
    if (total < 0) { total = 0; }
    const h = Math.floor(total / 60);
    const m = total % 60;
    return this.pad2(h) + ':' + this.pad2(m);
  }

  private convertirAlmuerzoAMinutos(valor: any): number {
    if (valor === null || valor === undefined || String(valor).trim() === '') {
      return 0;
    }

    const texto = String(valor).trim();
    if (texto.indexOf(':') >= 0) {
      return this.hhmmToMinutes(texto);
    }

    const numero = Number(texto);
    if (!isFinite(numero) || numero <= 0) { return 0; }
    return numero < 24 ? Math.round(numero * 60) : Math.round(numero);
  }

  private claveFila(item: any): string {
    return (item.FECHA || '') + '|' + (item.CODIGO || '') + '|' + (item.NOMBRE || '');
  }

  private recalcularHorasTrabajadasPorFila(): void {
    this.horasTrabajadasPorClave = {};
    const grupos: { [key: string]: any[] } = {};

    let fechaActual = '';
    let codigoActual = '';
    let nombreActual = '';

    for (let item of this.informetrabajadores) {
      if (!item || item.FECHA === '--') {
        continue;
      }

      if (item.FECHA && item.FECHA.trim() !== "") { fechaActual = item.FECHA; }
      if (item.CODIGO && item.CODIGO.trim() !== "") { codigoActual = item.CODIGO; }
      if (item.NOMBRE && item.NOMBRE.trim() !== "") { nombreActual = item.NOMBRE; }

      const itemVirtual = { FECHA: fechaActual, CODIGO: codigoActual, NOMBRE: nombreActual };
      const clave = this.claveFila(itemVirtual);

      if (!grupos[clave]) { grupos[clave] = []; }
      grupos[clave].push(item);
    }

    let minGlobales = 0;
    let minPrevistosGlobales = 0;
    let minAlmuerzoGlobales = 0;

    Object.keys(grupos).forEach(clave => {
      const filas = grupos[clave];
      let minDia = 0;

      // El informe actual devuelve una fila resumen por día con
      // PICADA_INICIAL/PICADA_FINAL. Mantenemos también el cálculo antiguo
      // para respuestas que todavía traigan PICADA y SENTIDO.
      const filasResumen = filas.filter(f => f && f.NOMBRE !== 'SAL' &&
        (f.PICADA_INICIAL || f.PICADA_FINAL));
      if (filasResumen.length) {
        filasResumen.forEach(filaResumen => {
          const inicioTexto = filaResumen.PICADA_INICIAL || filaResumen.PICADA;
          const finalTexto = filaResumen.PICADA_FINAL;
          const inicio = this.hhmmToMinutes(inicioTexto);
          const final = (finalTexto && String(finalTexto).toLowerCase() !== 'no')
            ? this.hhmmToMinutes(finalTexto)
            : 24 * 60;

          if (inicioTexto && finalTexto && final >= inicio) {
            minDia += final - inicio;
          } else if (inicioTexto && (!finalTexto || String(finalTexto).toLowerCase() === 'no')) {
            minDia += Math.max(0, final - inicio);
          }
        });
      } else {
        filas.sort((a, b) => this.hhmmToMinutes(a.PICADA) - this.hhmmToMinutes(b.PICADA));
        let entrada: number = null;

        for (const fila of filas) {
          const minActual = this.hhmmToMinutes(fila.PICADA);
          const sentido = (fila.SENTIDO || '').toLowerCase().trim();

          if (sentido === 'entra') {
            entrada = minActual;
          } else if (sentido === 'sale' && entrada !== null) {
            minDia += Math.max(0, minActual - entrada);
            entrada = null;
          }
        }
      }

      let almuerzoDia = 0;
      let minutosSinTrabajarReales = 0;
      for (const f of filas) {
        const minutosConfigurados = this.convertirAlmuerzoAMinutos(f.ALMUERZO);
        if (minutosConfigurados > 0) {
          almuerzoDia = minutosConfigurados;
        }
        const pausaReal = Number(f && f._MINUTOS_SIN_TRABAJAR_REAL);
        if (f && f._PICADA_VIRTUAL_MEDIANOCHE && isFinite(pausaReal) && pausaReal > minutosSinTrabajarReales) {
          minutosSinTrabajarReales = pausaReal;
        }
      }

      const minDiaCalculado = Math.max(0, minDia - almuerzoDia - minutosSinTrabajarReales);
      const totalHHMM = this.minutesToHHMM(minDiaCalculado);
      this.horasTrabajadasPorClave[clave] = totalHHMM;
      minGlobales += minDiaCalculado;
      minAlmuerzoGlobales += almuerzoDia;

      let valorPrevistas = '00:00';
      for (let f of filas) {
        if (f.HORAS_PREVISTAS && f.HORAS_PREVISTAS !== "0") {
          valorPrevistas = f.HORAS_PREVISTAS;
          break;
        }
      }
      minPrevistosGlobales += this.hhmmToMinutes(this.formateaHorasPrevistas(valorPrevistas));
    });

    this.totalRegistros = Object.keys(grupos).length;
    this.totalHorasTrabajadas = this.minutesToHHMM(minGlobales);
    this.totalHorasAlmorzando = this.minutesToHHMM(minAlmuerzoGlobales);

    const balance = minGlobales - minPrevistosGlobales;
    this.totalHorasExtras = balance > 0 ? this.minutesToHHMM(balance) : '00:00';
    this.totalHorasDefecto = balance < 0 ? this.minutesToHHMM(Math.abs(balance)) : '00:00';
  }

  private convertirPrevistasAMinutos(valor: any): number {
    if (!valor) { return 0; }
    if (String(valor).includes(':')) { return this.hhmmToMinutes(valor); }
    const n = Number(valor);
    return isNaN(n) ? 0 : Math.round(n * 60);
  }

  obtenerHorasTrabajadasFila(item: any): string {
    if (!item) { return '00:00'; }
    const clave = this.claveFila(item);
    return this.horasTrabajadasPorClave[clave] || '00:00';
  }


  obtenerFechaVisualFila(index: number): string {
    for (let i = index; i >= 0; i--) {
      if (this.informetrabajadores[i] && this.informetrabajadores[i].FECHA && this.informetrabajadores[i].FECHA.trim() !== '') {
        return this.informetrabajadores[i].FECHA;
      }
    }
    return '';
  }
  
  obtenerDiaVisualFila(index: number): string {
    for (let i = index; i >= 0; i--) {
      if (this.informetrabajadores[i] && this.informetrabajadores[i].DIA && this.informetrabajadores[i].DIA.trim() !== '') {
        return this.informetrabajadores[i].DIA;
      }
    }
    return '';
  }
  
  colorFilaPorDia(index: number): string {

  if (!this.informetrabajadores || this.informetrabajadores.length == 0) {
    return '';
  }

  let colorIndex = 0;

  for (let i = 1; i <= index; i++) {

    if (
      this.informetrabajadores[i].FECHA != this.informetrabajadores[i-1].FECHA
    ) {
      colorIndex++;
    }

  }

  return (colorIndex % 2 == 0) ? 'fila-dia-par' : 'fila-dia-impar';
}

  obtenerCodigoVisualFila(index: number): string {
    for (let i = index; i >= 0; i--) {
      if (this.informetrabajadores[i] && this.informetrabajadores[i].CODIGO && this.informetrabajadores[i].CODIGO.trim() !== '') {
        return this.informetrabajadores[i].CODIGO;
      }
    }
    return '';
  }
  
  obtenerNombreVisualFila(index: number): string {
    for (let i = index; i >= 0; i--) {
      if (this.informetrabajadores[i] && this.informetrabajadores[i].NOMBRE && this.informetrabajadores[i].NOMBRE.trim() !== '') {
        return this.informetrabajadores[i].NOMBRE;
      }
    }
    return '';
  }

  openPicajes(codigotrabajador, nombretrabajador, DIA) {
    this.scrollGuardado = this.content ? this.content.scrollTop : 0;
    this.variablesglobales.DIA=DIA;
    let callback = (datosActualizados) => {
      return new Promise<void>((resolve) => {
        this.recargarInforme().then(() => {
          this.deboRestaurarScroll = true;
          resolve();
        });
      });
    };

    this.navCtrl.push(PicajesPage, {
      codigotrabajador: codigotrabajador,
      nombretrabajador: nombretrabajador,
      DIA: DIA,
      callback: callback
    });
  }

  formateaHorasPrevistas(valor: any): string {
    if (valor === null || valor === undefined || valor === '') {
      return '00:00';
    }

    const n = Number(valor);

    if (isNaN(n)) {
      return valor;
    }

    if (n > 24) {
      const horas = Math.floor(n / 60);
      const minutos = n % 60;

      return ((horas < 10) ? ('0' + horas) : '' + horas) +
        ':' +
        ((minutos < 10) ? ('0' + minutos) : '' + minutos);
    }

    const horas = Math.floor(n);
    const minutos = Math.round((n - horas) * 60);

    if (minutos === 60) {
      const h = horas + 1;
      return ((h < 10) ? ('0' + h) : '' + h) + ':00';
    }

    return ((horas < 10) ? ('0' + horas) : '' + horas) +
      ':' +
      ((minutos < 10) ? ('0' + minutos) : '' + minutos);
  }


  

  creaelinformepequeno() {
    this.tipodeinforme = "normal";
  }

  creaelinformenormal() {
    this.tipodeinforme = "normal";
    this.creaelinforme();
  }

  creaelinformedetallado() {
    this.tipodeinforme = "detallado";
    this.creaelinforme();
  }

  creaelinformeporobras() { }

  creaelinforme() {
    this.recargarInforme();
  }

  onChange($event) {
    this.FechaIni = $event.from;
    this.FechaFin = $event.to;
    //console.log("pasa1");
    this.creaelinforme();
  }

  hacerinforme() {
    this.Informe = "S";
  }

  radioChecked(valor) {
    if (valor == "Fecha" || valor == "Trabajador" || valor == "Obra") {
      this.filtrofecha = "S";
      this.filtrotrabajador = "S";
      this.filtroobra = "S";
    }
  }

  read(bstr: string) { }

  write(): XLSX.WorkBook {
    const datos = [...this.informetrabajadores];

    datos.push({
      FECHA: '',
      DIA: '',
      CODIGO: '',
      NOMBRE: '',
      EMPRESA: '',
      OBRA: 'TOTALES',
      PICADA_INICIAL: '',
      PICADA_FINAL: '',
      HORAS_TRANSCURRIDAS: this.totalHorasTranscurridas,
      HORAS_TRABAJADAS: this.totalHorasTrabajadas,
      HORAS_PARADAS: this.totalHorasParadas,
      HORAS_ALMORZANDO: this.totalHorasAlmorzando,
      HORAS_EXTRAS: this.totalHorasExtras
    });

    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(datos);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Hoja1');

    return wb;
  }

  async import() { }

  async export() {
    const wb: XLSX.WorkBook = this.write();
    const filename: string = "informepicajes.xlsx";
    try {
      const wbout: ArrayBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
      const blob: Blob = new Blob([wbout], { type: 'application/octet-stream' });

      const target: string = this.file.documentsDirectory || this.file.externalDataDirectory || this.file.dataDirectory || '';
      const dentry = await this.file.resolveDirectoryUrl(target);
      const url: string = dentry.nativeURL || '';

      await this.file.writeFile(url, filename, blob, { replace: true });
    } catch (e) {
      XLSX.writeFile(wb, filename);
    }
  }

  obtenerobras(filtro) {
    this.funciones.obtieneobras(filtro).then(
      data => {
        this.sobras = data;
      }
    ).catch(error => {
      console.log(error);
    });
  }

  obtenerturnos(filtro) {
    this.funciones.obtieneturnos(filtro).then(
      data => {
        this.turnos = data;
      }
    ).catch(error => {
      console.log(error);
    });
  }

  obtenerempresas(filtro) {
    this.funciones.obtieneempresas(filtro).then(
      data => {
        this.empresas = data;
      }
    ).catch(error => {
      console.log(error);
    });
  }

  obtenertrabajadores(filtro) {
    this.funciones.obtienetrabajadores(filtro).then(
      data => {
        this.trabajadores = data;
      }
    ).catch(error => {
      console.log(error);
    });
  }

  valChange(campo: string, value: string): void {
    if (value == "Todos") {
      value = this.valo;
    }

    switch (campo) {
      case "TRABAJADOR":
        this.valortrabajador = value;
        this.variablesglobales.CODIGOTRABAJADOR = value;
        this.creaelinforme();
        break;

      case "OBRA":
        this.valorobra = value;
        this.creaelinforme();
        break;

      case "TURNO":
        this.valorturno = value;
        this.creaelinforme();
        break;

      case "EMPRESA":
        this.valorempresa = value;
        this.creaelinforme();
        break;
    }
  }

  ponencampo(campo: string, value: string): void { }

  probar() { }

  pintahoja(codigo) { }
}



// WEBPACK FOOTER //
// ./src/pages/informes/informes.ts